// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"295":"793705e3","679":"729f853a"}[chunkId] + ".chunk.js";
};